/**
 * External dependencies
 */
import { __ } from '@wordpress/i18n';
import { Component } from '@wordpress/element';
import { PropTypes } from 'prop-types';
import apiFetch from '@wordpress/api-fetch';

/**
 * Internal dependencies
 */
import { formatDuration, getHumanReadableDate } from '../../includes/date-utils';

class EventItem extends Component {
	constructor() {
		super( ...arguments );

		this.state = {
			available: true,
			loading: false,
		};
	}

	onClickBook = () => {
		const { serverDate, productId, available: availableData } = this.props.data;
		const { product, product: { permalink } } = this.props;
		const { available: availableState } = this.state;
		const available = availableData && availableState;
		const isBookable = available && ( ! ( product.has_persons || product.has_resources || 'customer' === product.duration_type ) );

		this.setState( { loading: true } );

		if ( ! isBookable ) {
			window.location.href = permalink;
			return;
		}

		apiFetch( {
			url: wc_bookings_availability_args.ajax_url + '=wc_bookings_add_booking_to_cart' + '&product_id=' + productId + '&date=' + encodeURIComponent( serverDate ) + '&security=' + wc_bookings_availability_args.nonces.add_booking_to_cart,
		} )
			.then( ( data ) => {
				if ( data.booked ) {
					this.setState( { available: false, loading: false } );

					window.location.href = wc_bookings_availability_args.checkout_url;
				} else {
					window.location.href = data.link;
				}
			} );
	}

	render() {
		const { isPreview, addSubheader, product } = this.props;
		const { name } = product;
		const { date, placeholder, available: availableData } = this.props.data;
		const { available: availableState, loading } = this.state;
		const priceHtml = product.price_html;
		const available = availableData && availableState;
		let listClassName = 'wc-bookings-availability-item';

		if ( placeholder ) {
			listClassName += ' wc-bookings-availability-item-is-placeholder';
		}

		let buttonText = ( product.has_persons || product.has_resources || 'customer' === product.duration_type ) ? __( 'Select options', 'woocommerce-bookings-availability' ) : __( 'Book now', 'woocommerce-bookings-availability' );

		let buttonClassName = 'wp-block-button__link wc-bookings-availability-book-button';

		if ( ! available ) {
			buttonText = __( 'Sold out', 'woocommerce-bookings-availability' );
			buttonClassName += ' wc-bookings-availability-item-sold-out';
		}

		return (
			<li className={ listClassName } >
				{ addSubheader &&
					<div className="wc-bookings-availability-item-subheader">
						<span>{ getHumanReadableDate( date ) }</span>
					</div>
				}
				<div className="wc-bookings-availability-item-body">
					<div className="wc-bookings-availability-item-information" >
						<div>
							<h3>
								<a href={ product.permalink }>{ name }</a>
							</h3>
							<div><span>{ formatDuration( product, date ) }</span></div>
							<div className="wc-bookings-availability-item-price" dangerouslySetInnerHTML={ { __html: priceHtml } } />
						</div>
					</div>
					<div className="wp-block-button">
						{ ( isPreview || ! available ) ? (
							<span className={ buttonClassName }>
								{ buttonText }
							</span>
						) : (
							<button onClick={ this.onClickBook } disabled={ loading } className={ buttonClassName }>
								{ buttonText }
							</button>
						) }
					</div>
				</div>
			</li>
		);
	}
}

EventItem.propTypes = {
	/**
	 * Availability data from wc_bookings_find_booking_slots ajax endpoint.
	 */
	data: PropTypes.shape( {
		booked: PropTypes.number,
		available: PropTypes.number,
		resources: PropTypes.object,
		productId: PropTypes.number,
		title: PropTypes.string,
		date: PropTypes.date,
		serverDate: PropTypes.string,
		placeholder: PropTypes.bool,
		duration: PropTypes.number,
		durationUnit: PropTypes.string,
	} ).isRequired,
	/**
	 * Sets up component for in-editor preview if true.
	 */
	isPreview: PropTypes.bool,
	addSubheader: PropTypes.bool,
	product: PropTypes.object.isRequired,
};

EventItem.defaultProps = {
	addSubheader: false,
};

export default EventItem;
